import React, { useContext, useState, useEffect, useDeferredValue } from 'react';

import { useContainer } from '../../../../hooks/useContainer'
import { useContainerPrice } from "../../../../hooks/useContainerPrice";
import { AppContext } from "../../../../providers/appProvider"
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination';
import AddContainerModal from '../Add/Add';  

import cl from './ContainerList.module.css'   
import ContainerSearch from '../Search/ContainerSearch'; 
import Plus from '../../../../assets/Icon/Plus'; 
import Item from './Item'; 
import RemarkModal from '../RemarkModal/RemarkModal';
import TotalPrice from '../TotalPrice/TotalPrice';
import { useCargo } from '../../../../hooks/useCargo';
import Report from '../Report/Report';
import Excel from "../../../../assets/Icon/Excel";

const ContainerList = () => {
  
  const [searchTerm, setSearchTerm] = useState('');
  const { ContainerPriceService } = useContainerPrice(20, true);
  const { containerService } = useContainer(50, true);
  const { cargoService } = useCargo(-1, true); 
  const [currentRemark, setCurrentRemark] = useState(null);
  const [isRemarkOpen, setIsRemarkOpen] = useState(false);
  const [containerPrices, setContainerPrices] = useState([]);
  const { appState, app } = useContext(AppContext);
   
  const [isOpenAdd, setIsOpenAdd] = useState(false);

  useEffect(() => {
    ContainerPriceService.fetchList();
  }, []);

  console.log(ContainerPriceService.items)
  useEffect(() => {
    if (ContainerPriceService.items) {
      let pendingContainerPrices = []
      ContainerPriceService.items.forEach(el => {
        if(el.container_ids) {
          el.container_ids.forEach(e => {
            if(e.status === 'pending') {
              pendingContainerPrices.push({
                  id: 0,
                  container_number: e?.id,
                  bl_number: "",
                  booking_number: "",
                  ship_name: "",
                  sender_city_id: el.sender_city?.id,
                  reciever_city_id: el.reciever_city?.id,
                  sender_country_id: el.sender_country?.id,
                  reciever_country_id: el.reciever_country?.id,
                  container_price_id: parseInt(el.id),
                  agent_id: el.agent?.id,
          
                  total_price: 0,
                  other_price: 0,
                  frast_price: 0,
                  thc_price: 0,
          
                  is_transit: 0,
           
                  client_total_price: el.client_total_price,
                  client_other_price: 0,
                  client_frast_price: 0,
                  client_thc_price: 0,
          
                  client_land_other_price: 0,
                  land_other_price: 0,
          
                  land_type_id: el.land,
                  shipper_id: 0,
                  marine_line_id: el.marine_line?.id,
                  land_type_id: 0,
                  send_at: "",
                  open_at: "",
                  taken_at: "",
                  entry_at: "",
                  status_id: 1,
                  total_price: 0,
                  seal_number: "",
                  voyage_number: "",
                  gross_weight: 0,
                  frast_price: 0,
                  thc_price: 0,
              })
            }
          })
        }
      })
      setContainerPrices(pendingContainerPrices);
    }
  }, [ContainerPriceService.items]);

  console.log(containerPrices)

  const openAdd = () => {
    setIsOpenAdd(true);
  };

  const closeAdd = () => {
    setIsOpenAdd(false);
  }; 

  const openRemarkModal = (color, id, remarkType ) => {
    setCurrentRemark({ color, id, remarkType });
    setIsRemarkOpen(true);
  };

  const closeRemarkModal = ({ container, cargo, remarkType }) => {
    setCurrentRemark(null);
    setIsRemarkOpen(false);
  };
 
 
  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };


  const downloadExcel = () => {
    containerService.downloadExcel()
 };
 
  return <div style={{maxWidth: '1580px', marginLeft: 'auto', marginRight: 'auto'}}>

    <div className={cl.headMain}>
      <h1>კონტეინერები</h1>
      <TotalPrice sum={containerService.sum} />
    </div>

    
    <ContainerSearch containerService={containerService} onSearchChange={handleSearchChange} ></ContainerSearch>
      
    <Pagination
      total={containerService.total}
      perPage={containerService.filter.limit}
      current={containerService.filter.page}
      paginate={(page) => {
        containerService.setFilter({
          ...containerService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => {
        containerService.setFilter({
          ...containerService.filter,
          limit: limit,
        });
      }}
      >

      <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>

        { app.hasPermission("CONTAINER_ADD") &&
        <>   
            {isOpenAdd ? <span onClick={closeAdd} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>დამატება
            </span>  : <span onClick={() => openAdd()}  className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>დამატება
            </span> }
 
        </>
        }

        { app.hasPermission("EXPORT_EXCEL_REPORT") &&
          <>
              <Report cargoService={cargoService} containerService={containerService}> </Report>
          </>
        }



        { app.hasPermission("EXPORT_EXCEL_CONTAINERS") &&
          <>  
            <span  onClick={downloadExcel} className={cl.exelBtn}>
                <span className={cl.icon} > <Excel /></span>
                <span className={cl.text} > ექსპორტი </span>
                
            </span> 
          </>
        }


              
        </div>
        

    </Pagination>

 
    { app.hasPermission("CONTAINER_ADD") &&
        <>
            {isOpenAdd && <AddContainerModal containerService={containerService} isOpen={isOpenAdd}  onClose={() => setIsOpenAdd(false)} />}
        </>
    }

{/* 
    {
      app.hasPermission('CONTAINER_ADD') &&
      containerPrices.map((item) => {
        console.log(item);
        return (
          <AddContainerModal 
            containerService={containerService}
           // defaultContainer={item}
            isOpen={true}
            onClose={() => {
              setContainerPrices((prev) => prev.filter((container) => container.id !== item.id));
            }}
          />
        );
      })
    }

    */}
 
 
    {containerService.items.map((container, index) => (
        <Item  
          container={container}
          containerService={containerService}  
          openRemarkModal={openRemarkModal}
          searchTerm={searchTerm}
          key={index} 
        />
    ))}
 
    {isRemarkOpen && (
                <RemarkModal
                    containerService={containerService}
                    cargoService={cargoService}
                    isModalOpen={isRemarkOpen}
                    remarkData={currentRemark}
                    closeModal={closeRemarkModal}
                />
    )}
 
    {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}

    <Pagination
      total={containerService.total}
      perPage={containerService.filter.limit}
      current={containerService.filter.page}
      paginate={(page) => {
        containerService.setFilter({
          ...containerService.filter,
          page: page,
        });
      }}
      setLimit={(limit) => {
        containerService.setFilter({
          ...containerService.filter,
          limit: limit,
        });
      }}
    />
  </div>;
}
 
export default ContainerList;